import MEAL_PREFS from './meal-preferences-enum';
import FFP from './frequent-flyer-program-enum';
import formFieldCopyIDs from './form-field-copy-ids';

const travelerFormOptions = {

  EMERGENCY: [
    {
      copyID: 'EMERGENCY_MOTHER',
      value: 'Madre',
    },
    {
      copyID: 'EMERGENCY_FATHER',
      value: 'Padre',
    },
    {
      copyID: 'EMERGENCY_UNCLE',
      value: 'Tio',
    },
    {
      copyID: 'EMERGENCY_AUNT',
      value: 'Tia',
    },
    {
      copyID: 'EMERGENCY_COUSIN',
      value: 'Primo',
    },
    {
      copyID: 'EMERGENCY_COUSINA',
      value: 'Prima',
    },
    {
      copyID: 'EMERGENCY_NEPHEW',
      value: 'Sobrino',
    },
    {
      copyID: 'EMERGENCY_NIECE',
      value: 'Sobrina',
    },
    {
      copyID: 'EMERGENCY_BROTHER',
      value: 'Hermano',
    },
    {
      copyID: 'EMERGENCY_SISTER',
      value: 'Hermana',
    },
    {
      copyID: 'EMERGENCY_SON',
      value: 'Hijo',
    },
    {
      copyID: 'EMERGENCY_DAUGHTER',
      value: 'Hija',
    },
    {
      copyID: 'EMERGENCY_OTHER',
      value: 'Otro',
    },
  ],

  GENDER: [
    {
      copyID: 'PAX_MALE',
      value: 'M',
    },
    {
      copyID: 'PAX_FEMALE',
      value: 'F',
    },
  ],

  PHONE_TYPES: [
    {
      copyID: 'PAX_MOBILE',
      value: 'mobile',
    },
    {
      copyID: 'PAX_HOME',
      value: 'home',
    },
    {
      copyID: 'PAX_OFFICE',
      value: 'office',
    },
  ],

  PHONE_TYPES2: [
    {
      home: [
        {
          copyID: 'PAX_HOME',
          value: 'home',
        },
        {
          copyID: 'PAX_MOBILE',
          value: 'mobile',
        },
        {
          copyID: 'PAX_OFFICE',
          value: 'office',
        },
      ],
      mobile: [
        {
          copyID: 'PAX_HOME',
          value: 'home',
        },
        {
          copyID: 'PAX_MOBILE',
          value: 'mobile',
        },
        {
          copyID: 'PAX_OFFICE',
          value: 'office',
        },
      ],
      office: [
        {
          copyID: 'PAX_HOME',
          value: 'home',
        },
        {
          copyID: 'PAX_MOBILE',
          value: 'mobile',
        },
        {
          copyID: 'PAX_OFFICE',
          value: 'office',
        },
      ],
    },
  ],

  FREQUENT_FLYER_NONE: [
    {
      copyID: 'FFP_NONE',
      value: '',
    },
  ],

  CORPORATE_FREQUENT_FLYER_PROGRAMS : [
    {
      copyID: formFieldCopyIDs.corporateFrequentFlyerNumberAM,
      value: FFP.AEROMEXICO,
    },
    {
      copyID: formFieldCopyIDs.corporateFrequentFlyerNumberDelta,
      value: FFP.DELTA,
    },
  ],

  FREQUENT_FLYER_PROGRAMS: [
    {
      copyID: 'FFP_AEROMEXICO',
      value: FFP.AEROMEXICO,
    },
    {
      copyID: 'FFP_DELTA',
      value: FFP.DELTA,
    },
    {
      copyID: 'FFP_AEROLINEAS',
      value: FFP.AEROLINEAS,
    },
    {
      copyID: 'FFP_EUROPA',
      value: FFP.EUROPA,
    },
    {
      copyID: 'FFP_FRANCE',
      value: FFP.FRANCE,
    },
    {
      copyID: 'FFP_MIDDLE_EAST',
      value: FFP.MIDDLE_EAST,
    },
    {
      copyID: 'FFP_CHINA_AIRLINES',
      value: FFP.CHINA,
    },
    {
      copyID: 'FFP_CHINA_EASTERN',
      value: FFP.CHINA_EASTERN,
    },
    // {
    //   copyID: 'FFP_COPA',
    //   value: FFP.COPA,
    // },
    // {
    //   copyID: 'FFP_CZECH',
    //   value: FFP.CZECH,
    // },
    { copyID: 'FFP_ELAL',
      value:  FFP.ELAL,
    },
    {
      copyID: 'FFP_GARUDA',
      value: FFP.GARUDA,
    },
    {
      copyID: 'FFP_GOL',
      value: FFP.GOL,
    },
    {
      copyID: 'FFP_ALITALIA',
      value: FFP.ALITALIA,
    },
    {
      copyID: 'FFP_KLM',
      value: FFP.KLM,
    },
    {
      copyID: 'FFP_KENYA',
      value: FFP.KENYA,
    },
    {
      copyID: 'FFP_KOREAN',
      value: FFP.KOREAN,
    },
    {
      copyID: 'FFP_LATAM',
      value: FFP.LATAM,
    },
    {
      copyID: 'FFP_SAUDIA',
      value: FFP.SAUDIA,
    },
    {
      copyID: 'FFP_SAS',
      value: FFP.SAS,
    },
    {
      copyID: 'FFP_TAROM',
      value: FFP.TAROM,
    },
    {
      copyID: 'FFP_VIETNAM',
      value: FFP.VIETNAM,
    },
    {
      copyID: 'FFP_VIRGIN',
      value: FFP.VIRGIN_ATLANTIC,
    },
    {
      copyID: 'FFP_XIAMEN',
      value: FFP.XIAMEN,
    },
  ],

  MEAL_PREFERENCES: [
    {
      copyID: 'PAX_MEAL_NO_PREFERENCE',
      value: '',
    },
    {
      copyID: 'PAX_MEAL_INFANT',
      value: MEAL_PREFS.BBML,
    },
    {
      copyID: 'PAX_MEAL_SOFT',
      value: MEAL_PREFS.BLML,
    },
    {
      copyID: 'PAX_MEAL_CHILD',
      value: MEAL_PREFS.CHML,
    },
    {
      copyID: 'PAX_MEAL_DIABETIC',
      value: MEAL_PREFS.DBML,
    },
    {
      copyID: 'PAX_MEAL_FRUIT',
      value: MEAL_PREFS.FPML,
    },
    {
      copyID: 'PAX_MEAL_GLUTEN_FREE',
      value: MEAL_PREFS.GFML,
    },
    {
      copyID: 'PAX_MEAL_KOSHER',
      value: MEAL_PREFS.KSML,
    },
    {
      copyID: 'PAX_MEAL_LOW_CALORIE',
      value: MEAL_PREFS.LCML,
    },
    {
      copyID: 'PAX_MEAL_LOW_FAT',
      value: MEAL_PREFS.LFML,
    },
    {
      copyID: 'PAX_MEAL_LOW_SODIUM',
      value: MEAL_PREFS.LSML,
    },
    {
      copyID: 'PAX_MEAL_NON_LACTOSE',
      value: MEAL_PREFS.NLML,
    },
    {
      copyID: 'PAX_MEAL_NO_SALT',
      value: MEAL_PREFS.NSML,
    },
    {
      copyID: 'PAX_MEAL_SEAFOOD',
      value: MEAL_PREFS.SFML,
    },
    {
      copyID: 'PAX_MEAL_VEGAN',
      value: MEAL_PREFS.VGML,
    },
    {
      copyID: 'PAX_MEAL_LACTO',
      value: MEAL_PREFS.VLML,
    },
  ],

  DOCUMENT_TYPE: [
    {
      copyID: 'TIMATIC_ALIENSPASSPORTS',
      value: '1',
    },
    {
      copyID: 'TIMATIC_PERMANENTRESIDEN',
      value: '2',
    },
    {
      copyID: 'TIMATIC_REENTRYPERMIT',
      value: '3',
    },
    {
      copyID: 'TIMATIC_RESIDENTPERMIT',
      value: '4',
    },
  ],

  TRAVEL_TYPE: [
    {
      copyID: 'TIMATIC_VACATIONS',
      value: 'Vacation',
    },
    {
      copyID: 'TIMATIC_BUSSINESS',
      value: 'Business',
    },
    {
      copyID: 'TIMATIC_DUTY',
      value: 'Duty',
    },
  ],

  RESERVATION_TYPE: [
    {
      copyID: 'CHECK_IN_RESERVATION_TICKET_NUMBER',
      value: 'Reservation',
    },
    /* Descomentar cuando se tenga la opcion de realizar la peticion por ffn
    {
      copyID: 'PAX_FFP',
      value: 'Program_frecuent_traveler',
    }, */
  ],
};

export default travelerFormOptions;
